export const REACT_PORTAL_TYPE = Symbol.for('react.portal')
